import { assert } from '@varos/util-typescript';
import { ReportingLoaderBaseConfig } from '../../../../base';
import { FormCollectionLoader } from './formCollectionInterface';
import { FormCollectionAggregate } from './formCollectionModel';
import { CollectionLoader } from '../../../common/collection';

export function createFormCollectionLoader(
    config: ReportingLoaderBaseConfig & {
        collection: {
            loader: CollectionLoader;
        };
    }
): FormCollectionLoader {
    const {
        repository: { research },
        collection: { loader: collectionLoader },
    } = config;
    return {
        useLoad(context, props): FormCollectionAggregate {
            const collection = collectionLoader.useLoad(context, {
                collection: props.collection,
            });
            return {
                collection,
            };
        },
    };
}
